(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    class ProductPrice extends HTMLElement {
    constructor() {
      super();
      
      // Add touch support for mobile
      this.setupMobileTooltip();
    }
    
    setupMobileTooltip() {
      const tooltips = this.querySelectorAll('.price-info-tooltip');
      
      tooltips.forEach(tooltip => {
        tooltip.addEventListener('touchstart', (e) => {
          e.preventDefault();
          
          // Hide all other tooltips
          document.querySelectorAll('.price-info-tooltip').forEach(t => {
            if (t !== tooltip) {
              t.classList.remove('active');
            }
          });
          
          // Toggle current tooltip
          tooltip.classList.toggle('active');
        });
      });
      
      // Hide tooltip when clicking outside
      document.addEventListener('touchstart', (e) => {
        if (!e.target.closest('.price-info-tooltip')) {
          document.querySelectorAll('.price-info-tooltip').forEach(t => {
            t.classList.remove('active');
          });
        }
      });
    }
  }
  
  customElements.define('product-price', ProductPrice);
  } catch(e) { console.error(e); }
})();

})();
